<template>
  <div class="mall-item">
    <van-image
      class="item-image van-hairline--surround"
      lazy-load
      :src="data.image"
      fit="contain"
    />
    <div class="van-ellipsis item-name">{{ data.name }}</div>
    <div class="item-bootom">
      <span>{{ "积分" + data.score }}</span>
      <div>兑换</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mall-item",
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
.mall-item {
  background: #fff;
}
.item-image {
  width: 167px;
  height: 167px;
  border: 1px solid #707070;
}
.item-name {
  font-size: 16px;
  font-weight: 700;
  color: #232323;
}
.item-bootom {
  margin: 5px 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: red;
}
.item-bootom div {
  width: 70px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 10px;
  font-size: 13px;
  color: #fff;
  background-color: var(--color-main);
}
</style>